module.exports = __webpack_public_path__ + "static/media/3.e4198cb4.jpg";